<section id="splash-screen" class="align-items-center justify-content-center">
  <div class="m-3 m-md-0">
    <img id="logo" src="{{ 'logo.png' | path }}" alt="セレモニー" class="img-fluid" />
  </div>
</section>
